class Country {
    constructor(data) {
      this.Id = data.Id;
      this.Idiso3 = data.Idiso3;
      this.Name = data.Name;
    }
  }
  
  export default Country;
  